import Title from '../common/Title'

export default {
  data () {
    return {
      page: this.$route.params.id
    }
  },
  computed: {
    organizationLoading () {
      return this.$store.getters.organizationLoading
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  components: {
    appTitle: Title
  }
}
